'use strict';

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var DirSharded = require('./dir-sharded');

var DirFlat = require('./dir-flat');
/**
 * @typedef {import('./dir')} Dir
 * @typedef {import('./types').ImporterOptions} ImporterOptions
 */

/**
 * @param {Dir | null} child
 * @param {Dir} dir
 * @param {number} threshold
 * @param {ImporterOptions} options
 * @returns {Promise<DirSharded>}
 */


module.exports = /*#__PURE__*/function () {
  var _flatToShard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(child, dir, threshold, options) {
    var newDir, parent;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            newDir = dir;

            if (!(dir instanceof DirFlat && dir.directChildrenCount() >= threshold)) {
              _context2.next = 5;
              break;
            }

            _context2.next = 4;
            return convertToShard(dir, options);

          case 4:
            newDir = _context2.sent;

          case 5:
            parent = newDir.parent;

            if (!parent) {
              _context2.next = 14;
              break;
            }

            if (!(newDir !== dir)) {
              _context2.next = 13;
              break;
            }

            if (child) {
              child.parent = newDir;
            }

            if (newDir.parentKey) {
              _context2.next = 11;
              break;
            }

            throw new Error('No parent key found');

          case 11:
            _context2.next = 13;
            return parent.put(newDir.parentKey, newDir);

          case 13:
            return _context2.abrupt("return", flatToShard(newDir, parent, threshold, options));

          case 14:
            return _context2.abrupt("return", newDir);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));

  function flatToShard(_x, _x2, _x3, _x4) {
    return _flatToShard.apply(this, arguments);
  }

  return flatToShard;
}();
/**
 * @param {DirFlat} oldDir
 * @param {ImporterOptions} options
 */


function convertToShard(oldDir, options) {
  var newDir, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, key, child;

  return _regeneratorRuntime.async(function convertToShard$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          newDir = new DirSharded({
            root: oldDir.root,
            dir: true,
            parent: oldDir.parent,
            parentKey: oldDir.parentKey,
            path: oldDir.path,
            dirty: oldDir.dirty,
            flat: false,
            mtime: oldDir.mtime,
            mode: oldDir.mode
          }, options);
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context.prev = 3;
          _iterator = _asyncIterator(oldDir.eachChildSeries());

        case 5:
          _context.next = 7;
          return _regeneratorRuntime.awrap(_iterator.next());

        case 7:
          if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
            _context.next = 14;
            break;
          }

          _step$value = _step.value, key = _step$value.key, child = _step$value.child;
          _context.next = 11;
          return _regeneratorRuntime.awrap(newDir.put(key, child));

        case 11:
          _iteratorAbruptCompletion = false;
          _context.next = 5;
          break;

        case 14:
          _context.next = 20;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](3);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 20:
          _context.prev = 20;
          _context.prev = 21;

          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context.next = 25;
            break;
          }

          _context.next = 25;
          return _regeneratorRuntime.awrap(_iterator.return());

        case 25:
          _context.prev = 25;

          if (!_didIteratorError) {
            _context.next = 28;
            break;
          }

          throw _iteratorError;

        case 28:
          return _context.finish(25);

        case 29:
          return _context.finish(20);

        case 30:
          return _context.abrupt("return", newDir);

        case 31:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[3, 16, 20, 30], [21,, 25, 29]], Promise);
}